module.exports = __webpack_public_path__ + "img/h5-arrow-right.eb7e3c8d.png";